function NavSectionHeader({ label }: { label: string }) {
  return (
    <span className="text-body-3-emphasis text-text-tertiary inline-block h-[3.6rem] p-8">
      {label}
    </span>
  );
}

export { NavSectionHeader };
